<div class="swatch-container {{ size }}">
  <span
    class="swatch swatch-{{ selectedColorPalette.type }} {{ size }}"
    *ngFor="let color of palette"
    [style.background]="color"
  ></span>
</div>
